import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import DealersRoutes from "./App";
import "./App.css";
import "./dealers-theme.css";

/**
 * Dealers / auction app mounted under /dealers/* inside client-web.
 * Uses its own Redux store so it does not clash with the main client store.
 */
export default function DealersApp() {
  return (
    <Provider store={store}>
      <div className="dealers-app">
        <DealersRoutes />
      </div>
    </Provider>
  );
}
